import {ReactNode} from "react";

export default function Section({ children, className, id }: { children: ReactNode, className?: string, id: string }) {
    return <>
        <div id={id} className={`md:pt-24 pt-32 ${className || ''}`}>
            {children}
        </div>
    </>
}